module.exports =  {
  WAP_DOMAIN: 'https://kmalltest.kukahome.com/',
}



//////////////////
// WEBPACK FOOTER
// ./config/basics.config.js
// module id = 255
// module chunks = 33